<script>
import { onMount } from 'svelte';
import SearchForm from './SearchForm.svelte';
import Map from './Map.svelte';
import StoreList from './StoreList.svelte';
import {
    finalType,
    idDb,
} from '../stores.js';

export let isPro = false;
// console.log(`isPro : ${isPro}`);

let stores = [];
let searchQuery = '';
let searchRadius = 5; // Rayon par défaut
let clientType = 'particulier'; // Type de client par défaut
let loading = false;
let error = null;
let commandType = '';

if(isPro) {
    $idDb = 166;
    $finalType = 'professionnel';
}

if($finalType !='') {
    commandType = $finalType;
    clientType = $finalType; 
    $finalType = '';
}

async function searchStores(query, radius = 5, type = 'particulier') {
    loading = true;
    error = null;
    searchQuery = query;
    searchRadius = radius;
    clientType = type;
    
    try {
    // Appel au fichier PHP avec les paramètres de recherche, rayon et type de client
    // const response = await fetch(`http://localhost/comptoirtrappe.fr/search-stores.php?query=${encodeURIComponent(query)}&radius=${radius}&type=${type}`);
    const response = await fetch(`search-stores.php?query=${encodeURIComponent(query)}&radius=${radius}&type=${type}`);
    
    if (!response.ok) {
        throw new Error('Erreur lors de la recherche des magasins');
    }
    
    const data = await response.json();
    stores = data;
    
    if (stores.length === 0) {
        // Message spécifique si aucun résultat
        error = `Aucun magasin trouvé dans un rayon de ${radius} km autour de "${query}"`;
    }
    } catch (err) {
    error = err.message;
    stores = [];
    } finally {
    loading = false;
    }
}

// Pour les tests - simulation de données
onMount(() => {
    // Décommenter cette section pour tester avec des données factices
    // stores = [
    //   { id: 1, name: "Magasin Paris", address: "123 Rue de Paris", zipCode: "75001", city: "Paris", lat: 48.856614, lng: 2.3522219, distance: 0 },
    //   { id: 2, name: "Magasin Lyon", address: "456 Rue de Lyon", zipCode: "69001", city: "Lyon", lat: 45.764043, lng: 4.835659, distance: 0 },
    //   { id: 3, name: "Magasin Marseille", address: "789 Rue de Marseille", zipCode: "13001", city: "Marseille", lat: 43.296482, lng: 5.36978, distance: 0 }
    // ];
});
</script>

<main>
    {#if commandType != ''}
        <div class="as-container-neu">
            <div class="as-container mx-auto relative">
                <div class="as-text-center">
                    <div class="as-soustitre">Merci pour votre demande !</div>
                    <p class="">Nous vous remercions pour l'intérêt que vous portez à nos produits.</p>
                    <p class="">Vous allez recevoir un mail avec votre configuration.</p>
                    <p class=""><a href="https://comptoirtrappe.fr/linkToConfigPdf.php?id={$idDb}" target="_blank" style="font-style:italic;text-decoration:underline;">Vous pouvez télécharger votre demande en cliquant-ici</a></p>
                    <p style="font-weight:bold;">
                    Pour passer commande,<br /> merci de vous rendre chez l'un de nos distributeurs partenaires<br /> présents partout en France.
                    </p>
                    <p class="">Indiquez votre adresse pour trouver les points de vente<br /> les plus proches de chez vous</p>
                </div>
            </div>
        </div>
    {/if}
    <div class="store-locator">

            <div class="column search-column">
                <h2>Rechercher un magasin</h2>
                <SearchForm onSearch={searchStores} {commandType}/>
                {#if error} 
                    <!-- <div class="error-message">{error}</div> -->
                    <div class="error-message" style="text-align:center;">La ville renseignée n'est pas reconnue. Merci de vérifier l'orthographe</div>
                {/if}
            </div>
            
            <div class="column map-column">
                <h2>Carte des magasins</h2>
                <Map {stores} searchLocation={searchQuery} searchRadius={searchRadius} />
            </div>
       
            
            <div class="column stores-column">
                <h2>Liste des magasins</h2>
                {#if loading}
                    <div class="loading">Chargement en cours...</div>
                {:else if stores.length === 0}
                    <div class="no-results">
                    {#if error}
                        <!-- {error} -->
                        La ville renseignée n'est pas reconnue. Merci de vérifier l'orthographe
                    {:else}
                        Aucun magasin trouvé. Veuillez effectuer une recherche.
                    {/if}
                    </div>
                {:else}
                    <div class="results-info">
                    {stores.length} magasin(s) trouvé(s) pour les {clientType}s
                    {#if searchQuery}
                        dans un rayon de {searchRadius} km autour de "{searchQuery}"
                    {/if}
                    </div>
                    <StoreList {stores} {clientType} />
                {/if}
            </div>
    </div>
</main>

<style>
.as-text-center {
    text-align:center;
}
.as-text-center p {
    margin-bottom:25px;
}
.as-soustitre {
    font-family: 'introblack';
    font-size: 25px;
    line-height: 30px;
    margin-bottom: 30px;
}
.store-locator {
    /* display: flex; */
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    width: 100%;
    height: 100vh;
    max-height: 800px;
}

.column {
    /* flex: 1; */
    padding: 20px;
    border-right: 1px solid #ddd;
    overflow-y: auto;
}

@media only screen and (max-width: 768px) {
    .store-locator {
        grid-template-columns: 1fr;
        height: auto;
        max-height: none;
    }
}

.column:last-child {
    border-right: none;
}

.search-column {
    flex: 0 0 25%;
}

.map-column {
    flex: 0 0 40%;
}

.stores-column {
    flex: 0 0 35%;
}

h2 {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 1.2rem;
}

.error-message {
    color: red;
    margin-top: 10px;
}

.results-info {
    margin-bottom: 15px;
    padding: 8px;
    background-color: #e7f3ff;
    border-radius: 4px;
    font-size: 14px;
}

.loading, .no-results {
    margin-top: 20px;
    font-style: italic;
    color: #666;
}
</style>
